<template>
  <div class="pro">
    <div v-if="percent" class="progress-b">
      <b-progress :value="percent" :max="100" animated height="10" class="prog" />
    </div>
    <div v-if="percent" class="persent">{{ percent }}%</div>
  </div>
</template>

<script>
export default {
  props: {
    percent: {
      type: Number,
    },
  },
}
</script>

<style lang="scss" scoped>
.progress-b {
  margin: 15px auto;
  direction: ltr;
  width: 90%;
  position: relative;
  left: -20px;
}

.persent {
  width: 100%;
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 10px;
  position: relative;
  top: -28px;
  right: -10px;
}
</style>
